import { TimeEntry, TimeSheetValidation, TimeUser, TimeUserFeatures, UserRegistrationPeriod, WorkProjectType, WorkType } from '../api/generated/data-contracts';
import { ReportPeriod } from '../components/Contexts/GridContext/context';
import { validationRulesParameters } from '../Validation/validationRules';
import { RuleParams } from './Validator';

export const GetValidatorParameters = (
    timeEntries: TimeEntry[],
    timeSheetValidation: TimeSheetValidation,
    timeRows: UserRegistrationPeriod[],
    userReportingPeriod: ReportPeriod,
    user: TimeUser,
    config: TimeUserFeatures,
    allowedWorkTypes: WorkType[],
    projectTypes: WorkProjectType[],
    userCapacity: number,
) => {
    const defaultParams = [
        { key: 'user', value: user },
        { key: 'userPeriodId', value: userReportingPeriod.reportPeriodId },
        { key: 'timeEntries', value: timeEntries },
        { key: 'timeRows', value: timeRows },
        { key: 'timeSheetValidation', value: timeSheetValidation },
        { key: 'userReportingPeriod', value: userReportingPeriod },
        { key: 'config', value: config },
        { key: 'allowedWorkTypes', value: allowedWorkTypes },
        { key: 'projectTypes', value: projectTypes },
        { key: 'userCapacity', value: userCapacity },
    ];
    // config.d
    // const rules = timeSheetValidation.enabledRules.filter(_ => _.enabled);
    const rules = Object.entries(timeSheetValidation)
        .filter(([key, value]) => typeof value === 'boolean')
        .map(([key]) => key);

    const ruleParameters = rules.map(rule => ({ ruleName: rule, parameters: validationRulesParameters[rule] || [] }));

    const rulesWithParamsWithValues = ruleParameters.map(ruleParam => {
        // const paramValues = timeSheetValidation.allConfig.filter(c => ruleParam.parameters.some(p => p == c.key));
        const paramValues = ruleParam.parameters;

        return { ...ruleParam, values: [...paramValues, ...defaultParams] };
    });

    const mappedParams = values => values.reduce((acc, cur: any) => ({ ...acc, [cur.key]: cur.value }), {});

    // const validatorParams: RuleParams = rulesWithParamsWithValues.reduce((acc, cur: any) => ({ ...acc, [cur.ruleName]: mappedParams(cur.values) }), {});
    const validatorParams: RuleParams = rulesWithParamsWithValues.reduce((acc, cur) => ({ ...acc, [cur.ruleName]: mappedParams(cur.values) }), {});

    return validatorParams;
};
